import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dialog-hero" }
const _hoisted_2 = { class: "hero-icon-wrap" }
const _hoisted_3 = { class: "hero-text" }
const _hoisted_4 = {
  key: 0,
  class: "batch-tag-display"
}
const _hoisted_5 = { class: "batch-tag-code" }
const _hoisted_6 = { class: "device-list-wrap" }
const _hoisted_7 = { class: "list-header" }
const _hoisted_8 = { class: "list-count" }
const _hoisted_9 = { class: "row-index" }
const _hoisted_10 = {
  key: 1,
  class: "result-wrap"
}
const _hoisted_11 = { class: "result-info" }
const _hoisted_12 = { class: "result-title" }
const _hoisted_13 = { class: "result-sub" }
const _hoisted_14 = { class: "result-table" }
const _hoisted_15 = { class: "cell-deviceId" }
const _hoisted_16 = {
  key: 0,
  class: "dot dot-success"
}
const _hoisted_17 = {
  key: 1,
  class: "dot dot-fail"
}
const _hoisted_18 = {
  key: 0,
  class: "endpoint-id"
}
const _hoisted_19 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_20 = { style: {"text-align":"center"} }

import { ref, computed, watch } from "vue";
import { ElMessage } from "element-plus";
import {
  Plus,
  Delete,
  Check,
  CircleCheckFilled,
  WarningFilled,
} from "@element-plus/icons-vue";
import { preRegisterDevicesApi } from "@/api/cert/certBatchApi";


export default /*@__PURE__*/_defineComponent({
  __name: 'PreRegisterDevicesDialog',
  props: {
    modelValue: { type: Boolean },
    certBatchId: {},
    batchCode: {}
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const visible = ref(props.modelValue);
const remark = ref("");
const submitting = ref(false);
const isAppendMode = computed(() => !!props.certBatchId);
const deviceRows = ref<{ deviceId: string; name: string }[]>([
  { deviceId: "", name: "" },
]);
const resultData = ref<any[]>([]);
const isResultView = computed(() => resultData.value.length > 0);

const successCount = computed(
  () => resultData.value.filter((r) => r.success).length
);
const failureCount = computed(
  () => resultData.value.filter((r) => !r.success).length
);
const resultSummaryClass = computed(() =>
  failureCount.value === 0 ? "summary-success" : "summary-fail"
);
const resultIconColor = computed(() =>
  failureCount.value === 0 ? "#10b981" : "#f59e0b"
);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
    if (val) {
      deviceRows.value = [{ deviceId: "", name: "" }];
      resultData.value = [];
      remark.value = "";
    }
  }
);
watch(visible, (val) => emit("update:modelValue", val));

const addRow = () => {
  deviceRows.value.push({ deviceId: "", name: "" });
};

const removeRow = (index: number) => {
  deviceRows.value.splice(index, 1);
};

const handleClose = () => {
  deviceRows.value = [{ deviceId: "", name: "" }];
  resultData.value = [];
};

const closeDialog = () => {
  visible.value = false;
};

const handleSubmit = async () => {
  const validRows = deviceRows.value.filter((r) => r.deviceId.trim());
  if (validRows.length === 0) {
    ElMessage.warning("请至少输入一条设备ID");
    return;
  }

  const ids = validRows.map((r) => r.deviceId.trim());
  const dup = ids.filter((id, i) => ids.indexOf(id) !== i);
  if (dup.length > 0) {
    ElMessage.warning(`设备ID重复: ${dup.join(", ")}`);
    return;
  }

  submitting.value = true;
  try {
    const results = await preRegisterDevicesApi(
      validRows.map((r) => ({
        deviceId: r.deviceId.trim(),
        name: r.name.trim() || undefined,
      })),
      isAppendMode.value ? undefined : remark.value || undefined,
      props.certBatchId || undefined
    );

    if (results) {
      const success = results.filter((r: any) => r.success).length;
      const fail = results.filter((r: any) => !r.success).length;
      if (success > 0) {
        ElMessage.success(
          `成功录入 ${success} 台终端${fail > 0 ? `，${fail} 台失败` : ""}`
        );
      } else {
        ElMessage.warning("录入全部失败，请检查终端编号");
      }
      emit("success");
      visible.value = false;
    }
  } catch (e: any) {
    ElMessage.error(e.message || "录入失败");
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: isResultView.value ? '' : '录入终端设备',
    width: "640px",
    "close-on-click-modal": false,
    "show-close": true,
    class: "pre-dialog",
    onClose: handleClose
  }, {
    footer: _withCtx(() => [
      (!resultData.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              size: "large",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "large",
              loading: submitting.value,
              class: "submit-btn",
              onClick: handleSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Check))
                  ]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "确认录入", -1))
              ]),
              _: 1
            }, 8, ["loading"])
          ], 64))
        : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            size: "large",
            class: "submit-btn",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("完成", -1)
            ]))]),
            _: 1
          }))
    ]),
    default: _withCtx(() => [
      (!resultData.value.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_icon, {
                  size: 22,
                  color: "#fff"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", null, _toDisplayString(isAppendMode.value ? "追加设备到现有批次" : "录入新设备"), 1),
                _createElementVNode("p", null, _toDisplayString(isAppendMode.value
                ? "向当前批次追加新设备，共享同一套证书"
                : "填写设备硬件编号，支持批量录入，自动生成 endpointId"), 1)
              ])
            ]),
            (isAppendMode.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "batch-tag-label" }, "目标证书批次", -1)),
                  _createElementVNode("span", _hoisted_5, "证书 " + _toDisplayString(__props.batchCode), 1)
                ]))
              : _createCommentVNode("", true),
            (!isAppendMode.value)
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 1,
                  "label-position": "top",
                  class: "device-form"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注（可选）" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: remark.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((remark).value = $event)),
                          placeholder: "如：第一批船载终端",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "设备列表", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(deviceRows.value.length) + " 台", 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceRows.value, (row, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: "device-input-row"
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(idx + 1), 1),
                  _createVNode(_component_el_input, {
                    modelValue: row.deviceId,
                    "onUpdate:modelValue": ($event: any) => ((row.deviceId) = $event),
                    placeholder: "设备ID（硬件唯一编号）",
                    size: "default",
                    class: "row-input"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_input, {
                    modelValue: row.name,
                    "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                    placeholder: "名称（可选）",
                    size: "default",
                    class: "row-input-name"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    icon: _unref(Delete),
                    circle: "",
                    size: "default",
                    disabled: deviceRows.value.length <= 1,
                    onClick: ($event: any) => (removeRow(idx))
                  }, null, 8, ["icon", "disabled", "onClick"])
                ]))
              }), 128)),
              _createVNode(_component_el_button, {
                class: "add-btn",
                plain: "",
                onClick: addRow
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "添加一行", -1))
                ]),
                _: 1
              })
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "tips" }, [
              _createElementVNode("div", { class: "tip-row" }, [
                _createElementVNode("span", { class: "tip-icon" }, "·"),
                _createTextVNode("设备ID填 IMEI / MAC / SN 等硬件唯一号 ")
              ]),
              _createElementVNode("div", { class: "tip-row" }, [
                _createElementVNode("span", { class: "tip-icon" }, "·"),
                _createTextVNode("设备ID不能重复，每台必须不同 ")
              ]),
              _createElementVNode("div", { class: "tip-row" }, [
                _createElementVNode("span", { class: "tip-icon" }, "·"),
                _createTextVNode("录入即激活，设备连接后自动上线，无需额外操作 ")
              ])
            ], -1))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: _normalizeClass(["result-summary", resultSummaryClass.value])
            }, [
              _createVNode(_component_el_icon, {
                size: 32,
                color: resultIconColor.value
              }, {
                default: _withCtx(() => [
                  (successCount.value > 0)
                    ? (_openBlock(), _createBlock(_unref(CircleCheckFilled), { key: 0 }))
                    : (_openBlock(), _createBlock(_unref(WarningFilled), { key: 1 }))
                ]),
                _: 1
              }, 8, ["color"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, " 录入" + _toDisplayString(successCount.value > 0 ? "完成" : "异常"), 1),
                _createElementVNode("div", _hoisted_13, " 共 " + _toDisplayString(resultData.value.length) + " 台 · 成功 " + _toDisplayString(successCount.value) + " · 失败 " + _toDisplayString(failureCount.value), 1)
              ])
            ], 2),
            _createElementVNode("table", _hoisted_14, [
              _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "deviceId"),
                  _createElementVNode("th", null, "endpointId"),
                  _createElementVNode("th", { style: {"width":"70px","text-align":"center"} }, "状态")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultData.value, (r, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: i,
                    class: _normalizeClass({ 'row-fail': !r.success })
                  }, [
                    _createElementVNode("td", _hoisted_15, [
                      (r.success)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17)),
                      _createTextVNode(" " + _toDisplayString(r.deviceId), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (r.success)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(r.endpointId), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(r.errorMessage), 1))
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["status-badge", r.success ? 'badge-success' : 'badge-fail'])
                      }, _toDisplayString(r.success ? "成功" : "失败"), 3)
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})